import { useRef, useEffect } from 'react'

export default function GameHistory({ history, onNewEntry }) {
  const listRef = useRef(null)
  const prevHistoryRef = useRef(history)

  useEffect(() => {
    if (listRef.current && listRef.current.lastChild) {
      listRef.current.lastChild.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
    }

    const prevHistory = prevHistoryRef.current
    const lastMessage = history[history.length - 1]
    const historyChanged =
      history.length !== prevHistory.length ||
      history.some((msg, index) => msg !== prevHistory[index])

    if (historyChanged && lastMessage && onNewEntry) {
      onNewEntry(lastMessage)
    }

    prevHistoryRef.current = history
  }, [history, onNewEntry])

  return (
    <div id="game-history" aria-label="Histórico da partida">
      <h3>Histórico</h3>
      <ul id="history-list" ref={listRef}>
        {history.map((msg, i) => (
          <li key={i}>{msg}</li>
        ))}
      </ul>
    </div>
  )
}
